// libraries
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Avatar, Button, List, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { green } from '@ant-design/colors';

// utils
import { txt } from '../../../../locales/i18n';

export function ImageListMobile({ dataSource, loading, handleAccept }: any): JSX.Element {
	const history = useHistory();

	function handleOpen(event: React.MouseEvent<HTMLElement, MouseEvent>, userId: number): void {
		event.stopPropagation();
		history.push(`/users/${userId}#image`);
	}

	function renderItem(item: Record<string, any>): JSX.Element {
		return (
			<List.Item onClick={() => history.push(`/users/${item.userId}`)}>
				<StyledListItemContainer>
					<div className="details-container">
						<Typography.Text type="secondary">{txt('global.username')}</Typography.Text>
						<Typography.Text ellipsis>{item.username}</Typography.Text>
						<Typography.Text type="secondary">{txt('global.age')}</Typography.Text>
						<Typography.Text ellipsis>{item.age}</Typography.Text>
					</div>

					<div className="image-container">
						<Avatar size={72} icon={<UserOutlined />} src={item.image} />
						<Avatar size={72} icon={<UserOutlined />} src={item.previousImage} />
					</div>

					<div className="action-container">
						<Button
							className="approved-button"
							type="primary"
							onClick={(event) => handleAccept(event, item.imageId)}
						>
							{txt('global.approve')}
						</Button>

						<Button type="primary" onClick={(event) => handleOpen(event, item.userId)}>
							{txt('global.open')}
						</Button>
					</div>
				</StyledListItemContainer>
			</List.Item>
		);
	}

	return (
		<List size="large" itemLayout="vertical" loading={loading} renderItem={renderItem} dataSource={dataSource} />
	);
}

const StyledListItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	.details-container {
		display: grid;
		grid-template-columns: auto 1fr;
		gap: 0ch 1ch;
	}

	.image-container {
		display: flex;
		justify-content: center;
		gap: 1rem;
	}

	.action-container {
		display: flex;
		justify-content: center;
		gap: 2ch;

		.approved-button {
			background: ${green.primary};
			border-color: ${green.primary};
		}
	}
`;
